var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', [_c('section', {
    staticClass: "login"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d29677f8","hasScoped":true}!./src/views/components/login/login.component.html
// module id = 826
// module chunks = 1